import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Section,Title,SubTitle,StyledMap } from './Section';

const ServiceTimes = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};

  return (
    <Section>
      <Container>
        <Title>Service Times & Location</Title>
        <Row>
          <Col md={6}>
            <SubTitle>Service Times</SubTitle>
            <ul>
              {(church.service_times || [
                'Sunday Worship - 9:00 AM & 11:00 AM',
                'Midweek Service - Wednesday 6:00 PM',
              ]).map((time, index) => (
                <li key={index}>{time}</li>
              ))}
            </ul>
          </Col>
          <Col md={6}>
            <SubTitle>Location</SubTitle>
            <p>{church.location || '123 Church Street, City, Country'}</p>
            <StyledMap
  title="Church Location Map"
  loading="lazy"
  allowFullScreen
  referrerPolicy="no-referrer-when-downgrade"
  src={church.map_url || 'https://www.google.com/maps/embed?...'} // Your default embed URL
/>
           
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default ServiceTimes;
